export default "__VITE_ASSET__XJo69Yl8__"